import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import Fingerprint2 from 'fingerprintjs2';
/**
 * 调用Fingerprint2函数
 * @param {*} cb
 */

export var getFingerprint2 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cb, reject) {
    var options;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = {};
            Fingerprint2.getPromise(options).then(function (components) {
              //参数
              var values = components.map(function (component) {
                return component.value;
              }); //指纹

              var murmur = Fingerprint2.x64hash128(values.join(''), 31);

              if (typeof cb === 'function') {
                cb([{
                  key: 'fingerprint2Murmur',
                  value: murmur
                }].concat(_toConsumableArray(components)));
              }
            }).catch(function (e) {
              reject([]);
              console.error('Fingerprint2 is error');
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getFingerprint2(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 *  异步获取设备指纹
 */

export var asyncGetFingerprint2 = function asyncGetFingerprint2() {
  return new _Promise(function (resolve, reject) {
    getFingerprint2(function (value) {
      resolve(value);
    }, reject);
  });
};